import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { installAudioUnlock } from './lib/audio/sfx';
import { ensureFlagFont } from './lib/flagFont';
import { registerServiceWorker } from './lib/pwa';

ensureFlagFont();

// El audio solo puede arrancar tras un gesto del usuario (Chrome, Safari, iPhone).
installAudioUnlock();

// PWA: service worker (instalable, portada sin conexión y aviso de versión nueva).
registerServiceWorker();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No se encontró el contenedor #root en index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);